import { ClientIntakeFormContextSelectors } from '@db-access/clientIntakeFormContext';
import { createSelector } from '@ngxs/store';
import type { ClientIntakeFormContext } from '@models/client-intake';
import type { ClientIntakeFormContextItem } from '@models/client-intake';
import { ClientIntakeFormType } from '@models/client-intake';

export class IntakeFormContextSelectors {
	private static readonly $IntakeFormContext =
		ClientIntakeFormContextSelectors._props.items;

	static readonly $context = createSelector(
		[IntakeFormContextSelectors.$IntakeFormContext],
		(items: ClientIntakeFormContextItem[]): ClientIntakeFormContext => {
			const clientsItem = items.find((item) => item.type === 'clients');
			const generalItem = items.find((item) => item.type === 'general');

			return {
				clients: clientsItem?.data ?? { all: [] },
				general: generalItem?.data ?? {
					id: '',
					name: '',
					type: ClientIntakeFormType.GENERAL,
				},
			};
		},
	);
}
